import React, {useEffect, useState} from 'react';
import style from '../../css/Staff.module.css';
import { StaffContainer } from '../others-component/StaffContainer';
import { Typography, Paper, Divider, Box, IconButton, LinearProgress } from '@mui/material';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';
import { useSelector } from 'react-redux';
import { data } from '../../storeredux';
import { RefreshRounded } from '@mui/icons-material';

export default function Staff(props) {
  const {setError} = props
  const staffwd = useSelector(data)
  const [staff,setStaff] = useState([])
  const [nPage, setNPage] = useState(1)
  const [statePage,setStatePage] = useState(0)
  const [loading,setLoading] = useState(true)
  const AutoPlayPlayer = autoPlay(SwipeableViews)
  useEffect(() => {
    setLoading(true)
    var length = staffwd['staff'].length
    if (length > 0)
      setNPage(Math.ceil(length / 20))
    var st = statePage*20
    setStaff(staffwd['staff'].slice(st,st+20))
    setLoading(false)
  },[staffwd])

  const refresh = () => {
    setLoading(true)
    if (statePage+1 < nPage) {
      var st = (statePage+1)*20
      setStaff(staffwd['staff'].slice(st,st+20))
      setStatePage(statePage+1)
    } else {
      setStaff(staffwd['staff'].slice(0,20))
      setStatePage(0)
    }
    setLoading(false)
  }

  const visible = () => (
    <Paper elevation={10} style={{borderRadius:20,backgroundColor:'#ffb380',padding:'15px'}}>
      <Box justifyContent='center' alignItems='center' display='flex' style={{minHeight:'inherit',position:'relative'}}>
        <Typography variant='h5' style={{width:'100%', color:'#ff6600',textAlign:'center'}}>
          <b>No Data</b>
        </Typography>
      </Box>
    </Paper>
  )

  const loadinit = () => (
    <Paper elevation={10} style={{borderRadius:20,backgroundColor:'#595959',padding:'15px'}}>
      <Box justifyContent='center' alignItems='center' display='flex' style={{minHeight:'inherit',position:'relative'}} sx={{flexWrap:'wrap',color:'white'}}>
        <LinearProgress color="inherit" sx={{width:'100%'}}/>
        <Typography variant='h6' color="inherit">Loading</Typography>
      </Box>
    </Paper>
  )

  return(
    <Box id='Staff' className={style.main}>
      <Box id='tit-ost' style={{marginTop: '50px',width:'100%',marginBottom:'40px'}}>
        <Box sx={{backgroundColor:'#66ff66', top:'10vh', left:'10vw',
          height: '50px', width: {xs:'30vw',md:'10vw'}, position:'relative', zIndex:-1}}/>
        <Box sx={{backgroundColor:'#66ff33', top:'12vh', right:'2vw',
          height: '50px', width: {xs:'30vw',md:'10vw'}, position:'relative', zIndex:-1}}/>
        <Box display='flex'>
          <Typography variant='h3' style={{backgroundColor:'#33cc33'}}>
            <span className={style.titleMain}><b>Our Staff</b></span>
          </Typography>
        </Box>
        <Divider variant='fullWidth' style={{backgroundColor:'#33cc33',height:'5px'}}/>
      </Box>
      <Box id='staff-con' className={style.submain}>
        {
          (staff.length > 0)?
            <AutoPlayPlayer interval={15000} enableMouseEvents>
              {
                staff.map((a,i) => (
                  <Box key={i} sx={{padding:'10px',display:'flex',alignItems:'center',justifyContent:'center'}}>
                    <StaffContainer
                      setError={setError}
                      name={a.name}
                      motivasi={a.motivasi}
                      departemen={a.departemen}
                      jabatan={a.jabatan}
                      image={(a.image && a.image.length !== 0)? (a.image):(null)}
                      facebook={a.facebook}
                      instagram={a.instagram}
                      tahun={a.tahun}
                      />
                  </Box>
                ))
              }
            </AutoPlayPlayer> :
          <Box justifyContent='center' alignItems='center' display='flex' className={style.card}>
            <Box style={{width:'100%',paddingLeft:'15px',paddingRight:'15px'}}>
              {
                (loading)?loadinit():visible()
              }
            </Box>
          </Box>
        }
      </Box>
      <Box className={style.submain} sx={{width:'100%',marginTop:'40px'}}>
        <IconButton color='primary' onClick={() => {refresh()}}>
          <RefreshRounded fontSize='large'/>
        </IconButton>
      </Box>
    </Box>
  )
}
